import { MediaCategoryType } from "../enums";
import { useMediaCategoriesSelector } from "./useMediaCategoriesSelector";

export const useMediaGenreListSelector = () => {
  const categories = useMediaCategoriesSelector();
  return categories.Entities.filter(
    (item) => item.CategoryTypeCode === MediaCategoryType.Main
  );
};
